<template>
  <div :class="sideBarOpened ? 'adp-sidebar-container' : 'adp-sidebar-container__employee-search'">
    <template v-if="loading && sideBarOpened">
      {{ $t('voc.loading') }}
    </template>

    <template v-if="!loading && sideBarOpened" >
      <div class="adp-subtitle pl-0">
        <span class="adp-h3">{{ $t('idp.employees') }} </span>
        <span class="adp-h3 adp-h3__green adp-h3__clickable" @click="$bvModal.show('org-tree-employee-search-modal');">
          {{ totalUsers }} {{ $tc('idp.men', items.length) }}
        </span>
        <div style="position: relative; display: inline">
          <button class="btn adp-btn" style="margin: 0 1.5rem 0 2rem" :disabled="!allEmployeesLoaded" @click="showContextMenu()">
            {{ $t('voc.actions') }} <img src="/images/arrow.svg" style="padding-left: 10px">
          </button>
          <div class="actions-button-error" v-if="showError" v-click-outside="() => {showError = false}">
            {{ $t('voc.warning_actions_employee') }}
          </div>
        </div>

        <!-- Actions Context Menu -->
        <div class="adp-task--crud-actions" v-if="contextMenu.isVisible && selectedItemsStatuses.length" :style="cmStyles"
             v-click-outside="() => hideContextMenu()" ref="actions">
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canAssignActivity()"
               @click="assignActivities()">
            {{ $t('idp.assign_idp') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canAssignWishes()"
               @click="assignWishes()">
            {{ $t('idp.assign_wish') }}
          </div>
          <a class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
             :href="`/catalog?pernumbers=${Object.keys(assignItems).join()}`">
            {{ $t('idp.add_learning_from_catalog') }}
          </a>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canChangeIdpStatus()"
               @click="changeIdpStatus()">
            {{ $t('idp.change_learning_status') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canLoadFiles()"
               @click="loadFiles()">
            {{ $t('idp.load_files') }}
          </div>
        </div>

        <div class="adp-report" style="display: inline-block;" v-if="role === 'hr' || role === 'manager' ">
          <button class="btn adp-btn" :disabled="!allEmployeesLoaded" @click="showReportContextMenu()">
            {{ $t('idp.download_report') }}
          </button>
        </div>

        <!-- Report Context Menu -->
        <div class="adp-task--crud-actions" v-if="reportContextMenu.isVisible" :style="reportCmStyles"
             v-click-outside="() => hideReportContextMenu()" ref="actions">
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="downloadIdpReport()">
            {{ $t('voc.report_idp') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="downloadMandatoryLearningReport()">
            {{ $t('voc.report_mandatory_learning') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="downloadTrainingDaysEmployeesReport()">
            {{ $t('voc.report_training_days_employees') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="downloadTrainingDaysResultReport()">
            {{ $t('voc.report_training_days_trainings') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="downloadWishesReport()">
            {{ $t('voc.report_wishes') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="downloadIdpStatusReport()">
            {{ $t('modal.idp_export_idp_status') }}
          </div>
        </div>

        <div class="adp-year adp-year__employee-list">
          <span class="nav-item dropdown">
            <a id="navbarAppDropdown" class="navbar-brand" href="#" role="button"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-weight: normal">
              {{ selectedYear }} <img src="/images/arrow_down_green.svg" alt="">
            </a>

              <div class="dropdown-menu dropdown-menu-right adp-dropdown" aria-labelledby="navbarAppDropdown">
              <span v-for="year in IDPYears"
                    @click="changeYear(year)"
                    class="dropdown-item adp-lang-item">{{ year }}
                <template v-if="selectedYear === year">&nbsp;&nbsp;&nbsp;
                  <img src="/images/check-mark.svg" alt="">
                </template>
              </span>
              </div>
            </span>
        </div>

      </div>

      <div class="adp-grid-table">
        <div class="adp-grid-row adp-grid-row__employees">
          <div class="adp-grid-cell adp-grid-cell__chbox">
            <b-form-checkbox v-model="selectAll"
                             :indeterminate="selectAllIndeterminate"
                             @change="selectAllHandler($event)"
                             :disabled="!allEmployeesLoaded"
            />
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('pernumber')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'pernumber'}">
                {{ $t('voc.table_pernumber') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('pernumber')" alt="sort">
              </span>
            </div>
            <input @input="searchEmployees" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterPernumber"
              @beforeinput="validateIntegerInput($event)">
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('name')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'name'}">
                {{ $t('voc.table_fullname') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('name')" alt="sort">
              </span>
            </div>
            <input @input="searchEmployees" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('position')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'position'}">
                {{ $t('voc.table_position') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('position')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="positions" :init-selected="filterPosition" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterPosition', 'positions')" :readonly="false">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('status')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'status'}">
                {{ $t('voc.table_status_idp') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('status')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="IDPStatuses" :init-selected="filterStatus" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterStatus', 'IDPStatuses')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('reservist')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'reservist'}">
                {{ $t('voc.table_reservist') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('reservist')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="reservists" :init-selected="filterReservist" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterReservist', 'reservists')" :localize="false">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('group')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'group'}">
                {{ $t('voc.table_group') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('group')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="groups" :init-selected="filterGroup" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterGroup', 'groups')" :localize="false">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('level')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'level'}">
                {{ $t('voc.table_level') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('level')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="levels" :init-selected="filterLevel" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterLevel', 'levels')" :localize="false">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('fired')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'fired'}">
                {{ $t('voc.table_status') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('fired')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="firedTypes" :init-selected="filterFired" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterFired', 'firedTypes')" :localize="false">
            </my-dropdown>
          </div>
        </div>
        <template v-if="!searchloading">
          <div style="cursor: pointer" class="adp-grid-row adp-grid-row__employees" v-for="(item, i) in items" :key="i" v-if="employees"
            :class="{'adp-filter-list-item__active': $route.params.pernumber === item.pernumber}"
            :style="statusStyles(item)">
          <div class="adp-grid-cell adp-grid-cell__chbox-hr">
            <b-form-checkbox v-model="item.is_checked" @change="selectEvent" @click.stop/>
          </div>
          <div class="adp-grid-cell adp-grid-cell__code" @click="viewSelectedEmployee(item.pernumber)">
            {{ item.pernumber }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{item.fullname}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{item.position}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title-yellow"
               :class="{'adp-grid-cell__title-green': item.status === 'agreed_by_hr',
                        'adp-grid-cell__title-red': item.status === 'not_formed' || item.status === 'on_approval'}"
               @click="viewSelectedEmployee(item.pernumber)">
            <div style="position: relative">
              {{ viewedStatusForHr(item) }}
              <div style="color: #E02020; font-size: 12px" v-if="item.has_expired_activities && item.status === 'agreed_by_hr'">
                {{ $t('idp.has_expired_activities') }}
              </div>
              <div style="color: #FFAA01; font-size: 12px" v-if="item.has_new_wishes && item.status === 'agreed_by_hr'">
                {{ $t('idp.has_new_wishes') }}
              </div>
            </div>
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{ viewedReservistStatus(item) }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{ item.group && item.group.trim() !== '' ? item.group : $t('voc.no') }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{ item.level && item.level.trim() !== '' ? item.level : $t('voc.no') }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{ item.fired_at && item.fired_at === '9000-01-01' ? $t('voc.active') : $t('voc.fired') }}
            <img src="/images/expired-activity.svg" v-if="item.has_expired_activities && item.status === 'agreed_by_hr'" style="height: 20px; ">
          </div>
        </div>
        </template>
        <template v-else>{{ $t('voc.loading') }}</template>
      </div>
      <org-tree-employee-search-modal v-on:apply-filter="updateFilterStructure" />
      <mass-wish-approval-modal :employees-props="assignItems" v-on:update-idp-activities="onIDPActivitiesUpdate" />
      <mass-change-status-modal :employees-props="assignItems" v-on:mass-change-status="onMassChangeStatus" />
      <mass-attach-files-modal :employees-props="assignItems" v-on:mass-attach-files="onMassAttachFiles"/>
      <mass-idp-export-modal :pernumbers="pernumbers" :export-type="exportType"/>
      <mass-training-export-modal :pernumbers="pernumbers" :export-type="trainingExportType"/>
      <mass-mandatory-export-modal :pernumbers="pernumbers" />
      <mass-idp-status-export-modal :pernumbers="pernumbers" />
    </template>

    <div class="adp-sidebar-close__employee-search" v-if="sideBarOpened" @click="closeSidebar">
        <div class="adp-sidebar-close__employee-search__circle">
          <img src="/images/sidebar-close.svg" style="position: absolute; left: 15px; top: 29px;">
          <img src="/images/sidebar-close.svg" style="position: absolute; left: 22px; top: 29px;">
        </div>
        <div class="adp-sidebar-close__employee-search__text">{{ $t('voc.employee_idp') }}</div>
    </div>

    <div class="adp-sidebar-open__employee-search" v-if="!sideBarOpened" @click="openSidebar">
      <div class="adp-sidebar-open__employee-search__circle">
        <img src="/images/sidebar-open.svg" style="position: absolute; right: 15px; top: 29px;">
        <img src="/images/sidebar-open.svg" style="position: absolute; right: 22px; top: 29px;">
      </div>
      <div class="adp-sidebar-open__employee-search__text">{{ $t('voc.employees') }}</div>
    </div>

    <div class="adp-pagination" v-if="!loading && sideBarOpened">
      <div class="adp-pagination-bnt" v-for="(page, index) in pages" v-if="page.url || page.label === '...'" @click="changePage(page.label)"
           :class="{'adp-pagination-bnt__active': page.active}">
        <span v-if="page.label === 'pagination.previous' && page.url"><</span>
        <span v-else-if="page.label === 'pagination.next' && page.url">></span>
        <span v-else>{{ page.label }}</span>
      </div>
      <div style="width: 190px; margin-left: 30px">
        <v-select style="background-color: white" label="text"
                  :options="itemsPerPage"
                  :clearable="false"
                  v-model="itemsPerPageSelected"
                  @option:selecting="selectItemsPerPage($event)"
        >
        </v-select>
      </div>
    </div>
  </div>
</template>

  <script>
  import {debounce} from 'lodash';
  import MyIDPFilter from "./MyIDPFilter";
  import MyDropdown from "./MyDropdown";
  import OrgTreeEmployeeSearchModal from "./modals/OrgTreeEmployeeSearchModal";
  import api from "../api";
  import Vue from "vue";
  import MassChangeStatusModal from "./modals/MassChangeStatusModal";
  import MassWishApprovalModal from "./modals/MassWishApprovalModal";
  import MassAttachFilesModal from "./modals/MassAttachFilesModal";
  import MassIdpExportModal from "./modals/exports/MassIdpExport";
  import MassTrainingExportModal from "./modals/exports/MassTrainingExport";
  import MassMandatoryExportModal from "./modals/exports/MassMandatoryExport.vue";
  import MassIdpStatusExport from "./modals/exports/MassIdpStatusExport.vue";

  export default {
    name: "EmployeeSearch",
    components: {
      'mass-attach-files-modal': MassAttachFilesModal,
      'my-idp-filter': MyIDPFilter,
      'my-dropdown': MyDropdown,
      'org-tree-employee-search-modal': OrgTreeEmployeeSearchModal,
      'mass-wish-approval-modal': MassWishApprovalModal,
      'mass-change-status-modal': MassChangeStatusModal,
      'mass-idp-export-modal': MassIdpExportModal,
      'mass-training-export-modal': MassTrainingExportModal,
      'mass-mandatory-export-modal': MassMandatoryExportModal,
      'mass-idp-status-export-modal': MassIdpStatusExport,
    },
    data: function () {
      return {
        showError: false,

        loading: true,
        searchloading: false,
        selectAll: false,
        selectAllIndeterminate: false,
        sideBarOpened: false,

        role: this.$role,

        employees: [],
        items: [],
        assignItems: {},

        filterPernumber: '',
        filterName: '',
        filterPosition: [],
        filterStatus: [],
        filterStructure: [],
        filterReservist: [],
        filterGroup: [],
        filterLevel: [],
        filterFired: ['active'],

        positions: [],
        IDPStatuses: [],
        reservists: [],
        groups: [],
        levels: [],
        firedTypes: [],

        contextMenu: {
          isVisible: false,
          left: 0,
        },
        reportContextMenu: {
          isVisible: false,
          left: 0,
        },
        selectedItemsStatuses: [],
        selectedItemsExpire: [],
        selectedItemsHasNewWishes: [],
        selectedYear: new Date().getFullYear(),

        pernumbers: [],
        exportType: 'idp',
        trainingExportType: 'employees',

        pages: [],
        activePage: 1,
        itemsPerPage: [
          {number: 50, text: `50 ${this.$t('idp.per_page')}`},
          {number: 100, text: `100 ${this.$t('idp.per_page')}`},
          {number: 200, text:`200 ${this.$t('idp.per_page')}`},
          {number: 0, text:`${this.$t('catalog.all')} ${this.$t('idp.per_page')}`},
        ],
        itemsPerPageCount: 100,

        sortColumn: '',
        sortDirection: '',
        lastUsedFilterOptions: '',

        totalUsers: 0,

        waitingResponse: false,
        allEmployees: [],
        allEmployeesLoaded: true,
      }
    },
    computed: {
      cmStyles() {
        return {
          top: '85px',
          left: `${this.contextMenu.left}px`,
          right: 'unset',
        };
      },
      reportCmStyles() {
        return {
          top: '85px',
          left: `${this.reportContextMenu.left}px`,
          right: 'unset',
        };
      },
      IDPYears() {
        const currentYear = new Date().getFullYear();
        let year = 2023;
        let years = [year];

        while (year !== currentYear) {
          year++;
          years.push(year);
        }

        return [...years, currentYear+1, currentYear+2, currentYear+3];
      },
      itemsPerPageSelected: {
        get() {
          return this.itemsPerPage.find(item => item.number === this.itemsPerPageCount).text
        },
        set({number}) {
          this.itemsPerPageCount = number;
        }
      }
    },
    methods: {
      async getFilterOptions() {
        let filters = {
          year: this.selectedYear,
          search_pernumber: this.filterPernumber,
          search_fio: this.filterName,
          idp_status: this.filterStatus,
          position: this.filterPosition,
          reservist: this.filterReservist,
          group: this.filterGroup,
          level: this.filterLevel,
          filter_pernumbers: this.filterStructure,
          fired_status: this.filterFired
        };

        const resp = await api.getEmployeeSearchFilters(filters);

        if (this.lastUsedFilterOptions !== 'positions' || this.filterPosition.length === 0) {
          this.positions = resp.data.position
            .map(item => ({id: String(item), code: String(item)}))
            .sort((a, b) => a.code.localeCompare(b.code));
        }

        if (this.lastUsedFilterOptions !== 'IDPStatuses' || this.filterStatus.length === 0) {
          this.IDPStatuses = resp.data.status.map(item => ({id: String(item), code: String(item)}));
          this.IDPStatuses.map(status => {
            if (status.id === 'on_approval') status.on_approval = true; // легаси для изменения надписи MyDropdown на странице сотрудников
          });
        }

        if (this.lastUsedFilterOptions !== 'reservists' || this.filterReservist.length === 0) {
          const uniqueReservists = resp.data.reserve;
          this.reservists = [];
          if (uniqueReservists.includes(0)) this.reservists.push({id: '0', code: this.$t('voc.no')});
          if (uniqueReservists.includes(1)) this.reservists.push({id: '1', code: this.$t('voc.yes')});
        }

        if (this.lastUsedFilterOptions !== 'groups' || this.filterGroup.length === 0) {
          this.groups = resp.data.group.map(item => {
            if (item === null || item === '' || item === undefined) return {id: 'no', code: this.$t('voc.no')};
            return {id: String(item), code: String(item)};
          });
        }

        if (this.lastUsedFilterOptions !== 'levels' || this.filterLevel.length === 0) {
          this.levels = resp.data.level.map(item => {
            if (item === null || item === '' || item === undefined) return {id: 'no', code: this.$t('voc.no')};
            return {id: String(item), code: String(item)};
          });
        }

        if (this.lastUsedFilterOptions !== 'firedTypes' || this.filterFired.length === 0) {
          const uniqueFiredTypes = resp.data.firedTypes;
          this.firedTypes = [];
          if (uniqueFiredTypes.includes('active')) this.firedTypes.push({id: 'active', code: this.$t('voc.active')});
          if (uniqueFiredTypes.includes('fired')) this.firedTypes.push({id: 'fired', code: this.$t('voc.fired')});
        }
      },

      statusStyles(user) {
        let styles = {};
        if (user.has_expired_activities && user.status === 'agreed_by_hr') styles['background-color'] = "#FEF8F8";
        if (user.pernumber === +this.$router.currentRoute.params.pernumber) styles['background-color'] = "#FAFCF2";
        if (user.fired_at !== '9000-01-01') styles.color = "#8f8f8f";
        return styles;
      },

      async changePage(val) {
        if(val === '...') {
          return;
        }

        if(val === 'pagination.previous') {
          val = Number(this.activePage) - 1;
        }

        if(val === 'pagination.next') {
          val = Number(this.activePage) + 1;
        }

        val = Number(val);

        this.activePage = val;
        if (val === 1) {
          val = null;
        }

        await this.getEmployees();
        await this.getFilterOptions();
      },

      async selectItemsPerPage(event) {
        this.loading = true;
        try {
          if (event.number === 0) {
            this.itemsPerPageCount = this.totalUsers;
          } else {
            event.number > 50 ? this.activePage = 1 : this.activePage;
            this.itemsPerPageCount = event.number;
          }
          await this.filterEmployee();
        } catch (e) {
          console.error(e);
        }
        this.loading = false;
      },

      async filterEmployee() {
        this.searchloading = true;
        // ждём пока предыдущий запрос отработает
        while (this.waitingResponse) {
          await new Promise((resolve) => setTimeout(resolve, 0));
        }
        let items = await this.searchItems();
        items.forEach(el => el.is_checked = Object.keys(this.assignItems).includes(String(el.pernumber)));
        this.items = JSON.parse(JSON.stringify(items));
        this.searchloading = false;
      },

      async searchItems() {
        this.waitingResponse = true;
        let items = this.employees;
        let data = {
          year: this.selectedYear,
          page: this.activePage,
          count: this.itemsPerPageCount,
          search_pernumber: this.filterPernumber,
          search_fio: this.filterName,
          idp_status: this.filterStatus,
          position: this.filterPosition,
          reservist: this.filterReservist,
          group: this.filterGroup,
          level: this.filterLevel,
          sort_column: this.sortColumn,
          sort_direction: this.sortDirection,
          filter_pernumbers: this.filterStructure,
          fired_status: this.filterFired
        };

        await this.getFilterOptions();

        let resp = await axios.post(`/search-paginate`, data);
        items = resp.data.data;
        this.employees = resp.data.data;
        this.pages = resp.data.links;
        this.totalUsers = resp.data.total;

        this.waitingResponse = false;
        return items;
      },

      updateFilterStructure(e) {
        this.resetSelectedItems();
        this.$set(this, 'filterStructure', e);
        this.filterEmployee();
      },

      async getEmployees(year = this.selectedYear) {
        this.loading = true;
        this.selectedYear = year;
        await this.filterEmployee();
        this.loading = false;
      },

      async selectAllHandler(event) {
        if (Object.keys(this.assignItems).length) {
          this.resetSelectedItems();
        } else {
          this.items = this.items.map(el => {el.is_checked = true; return el});
          this.selectAll = true;
          await this.getAllEmployees();
          this.selectAllIndeterminate = false;
          this.updateItemsChecked();
        }
      },

      resetSelectedItems() {
        this.items = this.items.map(el => {el.is_checked = false; return el});
        this.selectAll = false;
        this.selectAllIndeterminate = false;
        this.updateItemsChecked();
      },

      updateItemsChecked() {
        let checkedItems = {};
        let items = null;

        if (this.selectAll) {
          items = this.allEmployees.map(el => {
            el.is_checked = true;
            return el;
          });
        } else {
          items = this.items;
        }

        if (!this.selectAll && !this.selectAllIndeterminate) {
          this.assignItems = {};
          return;
        }

        items.filter(el => el.is_checked)
          .map(el => ({ ...el }))
          .forEach(item => {
            checkedItems[item.pernumber] = item
          });

        this.assignItems = {...checkedItems};
      },

      selectEvent() {
        let checkedElementsCnt = this.items.filter(el => el.is_checked).length;
        if (this.items.length === checkedElementsCnt) {
          this.selectAll = false;
          this.selectAllIndeterminate = true;
        } else if (this.items.length > checkedElementsCnt && checkedElementsCnt > 0) {
          this.selectAll = false;
          this.selectAllIndeterminate = true;
        } else {
          this.selectAll = false;
          this.selectAllIndeterminate = false;
        }

        this.updateItemsChecked();
      },

      getSortingIcon(sortingColumn) {
        if (sortingColumn !== this.sortColumn || this.sortDirection === '') {
          return '/images/sort.svg';
        } else if (this.sortDirection === 'asc') {
          return '/images/sort_active_asc.svg';
        } else if (this.sortDirection === 'desc') {
          return '/images/sort_active_desc.svg';
        }
      },

      sortChange(sortingColumn) {
        if (sortingColumn !== this.sortColumn) {
          this.sortColumn = sortingColumn;
          this.sortDirection = '';
        }

        if (this.sortDirection === '') {
          this.sortDirection = 'asc';
        } else if (this.sortDirection === 'asc') {
          this.sortDirection = 'desc';
        } else if (this.sortDirection === 'desc') {
          this.sortDirection = '';
          this.sortColumn = null;
        }

        this.filterEmployee();
      },

      onDropdownUpdate(e, property, filterOptionsName) {
        this.lastUsedFilterOptions = filterOptionsName;
        this.resetSelectedItems();
        this[property] = e;
        if (this.activePage > 1) this.changePage(1);
        this.filterEmployee();
      },

      searchEmployees: debounce(function () {
        this.resetSelectedItems();
        if (this.activePage > 1) this.changePage(1);
        this.filterEmployee();
      }, 700),

      closeSidebar() {
        if (this.$parent.$children.some(i => i.$options.name === 'IDP')) {
          this.sideBarOpened = false;
          this.$emit('close-sidebar');
        }
      },

      async openSidebar() {
        this.sideBarOpened = true;
        this.$emit('open-sidebar');

        const queryYear = Number(Object.fromEntries(new URLSearchParams(window.location.search)).la_y);
        if (queryYear && queryYear !== this.selectedYear) await this.changeYear(queryYear);

        await this.getEmployees();
        await this.getFilterOptions();
      },

      async viewSelectedEmployee(EmployeePernumber) {
        await this.$router.push({
          name: `${this.role}-employee`,
          params: { pernumber: EmployeePernumber },
          query: {la_y: String(this.selectedYear)}
        });
        await this.closeSidebar();
      },

      showContextMenu() {
        if (!Object.values(this.assignItems).length) {
          this.showError = true;
          setTimeout(() => this.showError = false, 2000)
          return;
        }
        this.contextMenu.isVisible = true;

        this.selectedItemsStatuses = Object.values(this.assignItems).map(item => item.status);
        this.selectedItemsExpire = Object.values(this.assignItems).map(item => item.has_expired_activities);
        this.selectedItemsHasNewWishes = Object.values(this.assignItems).map(item => item.has_new_wishes);

        this.$nextTick(() => {
          this.contextMenu.left = Number(event.pageX) - 50;
        });
      },

      showReportContextMenu() {
        if (!Object.values(this.assignItems).length) {
          this.showError = true;
          setTimeout(() => this.showError = false, 2000)
          return;
        }
        this.reportContextMenu.isVisible = true;

        this.$nextTick(() => {
          this.reportContextMenu.left = Number(event.pageX) - 50;
        });
      },
      hideContextMenu() {
        this.contextMenu.isVisible = false;
      },
      hideReportContextMenu() {
        this.reportContextMenu.isVisible = false;
      },
      canAssignActivity() {
        const statuses = this.selectedItemsStatuses;
        // const expiredActivities = this.selectedItemsExpire.includes(true);
        // const hasNewWishes = this.selectedItemsHasNewWishes.includes(true);

        if (this.role === 'hr') {
          return !statuses.includes('agreed_by_hr');
        }
        if (this.role === 'manager' || this.role === 'fmanager') {
          return !(statuses.includes('not_formed') || statuses.includes('agreed_by_hr') || statuses.includes('agreed_by_manager'));
        }
      },

      canAssignWishes() {
        if (this.role === 'hr') {
          const itemStatuses = Object.values(this.assignItems).map(item => {
            if (item.status === 'agreed_by_hr' && item.has_expired_activities) return 'can_assign_wishes';
            if (item.status === 'agreed_by_hr' && item.has_new_wishes) return 'can_assign_wishes';
            if (item.status === 'not_formed' || item.status === 'on_approval' || item.status === 'agreed_by_manager') {
              return 'can_assign_wishes';
            }
            return 'cant_assign_wishes';
          });

          return !itemStatuses.includes('cant_assign_wishes');
        }
      },

      canChangeIdpStatus() {
        const statuses = this.selectedItemsStatuses;

        if (this.role === 'hr')
          return !(statuses.includes('on_approval') || statuses.includes('agreed_by_manager') || statuses.includes('not_formed'));
      },

      canLoadFiles() {
        const statuses = this.selectedItemsStatuses;

        if (this.role === 'hr') return true;
        if (this.role === 'manager' || this.role === 'fmanager')
          return !(statuses.includes('on_approval') || statuses.includes('agreed_by_manager') || statuses.includes('not_formed'));
      },

      async assignActivities() {
        const pernumbers = Object.keys(this.assignItems);

        for await (const pernumber of pernumbers) {
          await api.agreeIDP(this.role, pernumber, new Date().getFullYear());
        }

        await this.getEmployees();
        await this.$router.push('/hr/');
      },

      assignWishes() {
        this.$bvModal.show('mass-wish-approval-modal');
      },

      async onIDPActivitiesUpdate() {
        this.$bvModal.hide('mass-draft-approval-modal');
        await this.getEmployees();
        this.resetSelectedItems();
      },

      changeIdpStatus() {
        this.$bvModal.show('mass-change-status-modal');
      },

      async onMassChangeStatus() {
        this.$bvModal.hide('mass-change-status-modal')
        await this.getEmployees();
        this.resetSelectedItems();
      },

      async onMassAttachFiles() {
        this.$bvModal.hide('mass-attach-files-modal')
        await this.getEmployees();
        this.resetSelectedItems();
      },

      loadFiles() {
        this.$bvModal.show('mass-attach-files-modal');
      },

      downloadIdpReport() {
        this.pernumbers = Object.keys(this.assignItems);
        this.exportType = 'idp';
        this.$nextTick(() => this.$bvModal.show('mass-idp-export-modal'));
      },

      downloadMandatoryLearningReport() {
        this.pernumbers = Object.keys(this.assignItems);
        this.$nextTick(() => this.$bvModal.show('mass-mandatory-export-modal'));
      },

      downloadTrainingDaysEmployeesReport() {
        this.pernumbers = Object.keys(this.assignItems);
        this.trainingExportType = 'employees';
        this.$nextTick(() => this.$bvModal.show('mass-training-export-modal'));
      },

      downloadTrainingDaysResultReport() {
        this.pernumbers = Object.keys(this.assignItems);
        this.trainingExportType = 'result';
        this.$nextTick(() => this.$bvModal.show('mass-training-export-modal'));
      },

      downloadWishesReport() {
        this.pernumbers = Object.keys(this.assignItems);
        this.exportType = 'wish';
        this.$nextTick(() => this.$bvModal.show('mass-idp-export-modal'));
      },

      async downloadIdpStatusReport() {
        this.pernumbers = Object.keys(this.assignItems);
        this.$nextTick(() => this.$bvModal.show('mass-idp-status-export-modal'));
      },

      viewedStatusForHr(item) {
        if (item.status === 'on_approval') return this.$t(`idp.on_approval_employee_list`);
        if (item.status === 'agreed_by_hr') return this.$t(`idp.agreed_by_hr_employee_list`);

        return this.$t(`idp.${item.status}`);
      },

      viewedReservistStatus(item) {
        if (item.reserve && item.reserve === '1') return this.$t('voc.yes');
        else return this.$t('voc.no');
      },

      async changeYear(year) {
        this.selectedYear = year;
        this.resetSelectedItems();
        await this.getEmployees(year);
      },

      async getAllEmployees() {
        let data = {
          year: this.selectedYear,
          page: 1,
          count: this.totalUsers,
          search_pernumber: this.filterPernumber,
          search_fio: this.filterName,
          idp_status: this.filterStatus,
          position: this.filterPosition,
          reservist: this.filterReservist,
          group: this.filterGroup,
          level: this.filterLevel,
          sort_column: this.sortColumn,
          sort_direction: this.sortDirection,
          filter_pernumbers: this.filterStructure,
          fired_status: this.filterFired
        };

        this.allEmployeesLoaded = false;
        await axios.post(`/search-paginate`, data)
          .then((resp) => this.allEmployees = resp.data.data)
          .then(() => this.allEmployeesLoaded = true);
      },
    },
    async mounted() {
      if (this.$router.currentRoute.name !== 'hr-employee') await this.openSidebar();
      this.selectedYear = this.$route.query.la_y ? Number(this.$route.query.la_y) : new Date().getFullYear();
    },
  }
</script>

<style scoped>

</style>
